export default {
  password: "",
  confirmPassword: "",
  email: "",
  name: "",
  telephone: "",
  roleIds: [],
  serviceContractsFilter: [],
  customerIds: [],
};
